function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { mergeProps as _mergeProps, createVNode as _createVNode } from "vue";
import { ref, reactive, withKeys, defineComponent } from "vue";
import { noop, pick, extend, addUnit, truthProp, isFunction, BORDER_TOP, BORDER_LEFT, unknownProp, numericProp, makeStringProp, callInterceptor, createNamespace } from "../utils";
import { popupSharedProps, popupSharedPropKeys } from "../popup/shared";
import { Popup } from "../popup";
import { Button } from "../button";
import { ActionBar } from "../action-bar";
import { ActionBarButton } from "../action-bar-button";

var _createNamespace = createNamespace("dialog"),
    _createNamespace2 = _slicedToArray(_createNamespace, 3),
    name = _createNamespace2[0],
    bem = _createNamespace2[1],
    t = _createNamespace2[2];

var dialogProps = extend({}, popupSharedProps, {
  title: String,
  theme: String,
  width: numericProp,
  message: [String, Function],
  callback: Function,
  allowHtml: Boolean,
  className: unknownProp,
  transition: makeStringProp("van-dialog-bounce"),
  messageAlign: String,
  closeOnPopstate: truthProp,
  showCancelButton: Boolean,
  cancelButtonText: String,
  cancelButtonColor: String,
  confirmButtonText: String,
  confirmButtonColor: String,
  showConfirmButton: truthProp,
  closeOnClickOverlay: Boolean
});
var popupInheritKeys = [].concat(_toConsumableArray(popupSharedPropKeys), ["transition", "closeOnPopstate"]);
var stdin_default = defineComponent({
  name: name,
  props: dialogProps,
  emits: ["confirm", "cancel", "keydown", "update:show"],
  setup: function setup(props, _ref) {
    var emit = _ref.emit,
        slots = _ref.slots;
    var root = ref();
    var loading = reactive({
      confirm: false,
      cancel: false
    });

    var updateShow = function updateShow(value) {
      return emit("update:show", value);
    };

    var close = function close(action) {
      var _a;

      updateShow(false);
      (_a = props.callback) == null ? void 0 : _a.call(props, action);
    };

    var getActionHandler = function getActionHandler(action) {
      return function () {
        if (!props.show) {
          return;
        }

        emit(action);

        if (props.beforeClose) {
          loading[action] = true;
          callInterceptor(props.beforeClose, {
            args: [action],
            done: function done() {
              close(action);
              loading[action] = false;
            },
            canceled: function canceled() {
              loading[action] = false;
            }
          });
        } else {
          close(action);
        }
      };
    };

    var onCancel = getActionHandler("cancel");
    var onConfirm = getActionHandler("confirm");
    var onKeydown = withKeys(function (event) {
      var _a, _b;

      if (event.target !== ((_b = (_a = root.value) == null ? void 0 : _a.popupRef) == null ? void 0 : _b.value)) {
        return;
      }

      var onEventType = {
        Enter: props.showConfirmButton ? onConfirm : noop,
        Escape: props.showCancelButton ? onCancel : noop
      };
      onEventType[event.key]();
      emit("keydown", event);
    }, ["enter", "esc"]);

    var renderTitle = function renderTitle() {
      var title = slots.title ? slots.title() : props.title;

      if (title) {
        return _createVNode("div", {
          "class": bem("header", {
            isolated: !props.message && !slots["default"]
          })
        }, [title]);
      }
    };

    var renderMessage = function renderMessage(hasTitle) {
      var message = props.message,
          allowHtml = props.allowHtml,
          messageAlign = props.messageAlign;
      var classNames = bem("message", _defineProperty({
        "has-title": hasTitle
      }, messageAlign, messageAlign));
      var content = isFunction(message) ? message() : message;

      if (allowHtml && typeof content === "string") {
        return _createVNode("div", {
          "class": classNames,
          "innerHTML": content
        }, null);
      }

      return _createVNode("div", {
        "class": classNames
      }, [content]);
    };

    var renderContent = function renderContent() {
      if (slots["default"]) {
        return _createVNode("div", {
          "class": bem("content")
        }, [slots["default"]()]);
      }

      var title = props.title,
          message = props.message,
          allowHtml = props.allowHtml;

      if (message) {
        var hasTitle = !!(title || slots.title);
        return _createVNode("div", {
          "key": allowHtml ? 1 : 0,
          "class": bem("content", {
            isolated: !hasTitle
          })
        }, [renderMessage(hasTitle)]);
      }
    };

    var renderButtons = function renderButtons() {
      return _createVNode("div", {
        "class": [BORDER_TOP, bem("footer")]
      }, [props.showCancelButton && _createVNode(Button, {
        "size": "large",
        "text": props.cancelButtonText || t("cancel"),
        "class": bem("cancel"),
        "style": {
          color: props.cancelButtonColor
        },
        "loading": loading.cancel,
        "onClick": onCancel
      }, null), props.showConfirmButton && _createVNode(Button, {
        "size": "large",
        "text": props.confirmButtonText || t("confirm"),
        "class": [bem("confirm"), _defineProperty({}, BORDER_LEFT, props.showCancelButton)],
        "style": {
          color: props.confirmButtonColor
        },
        "loading": loading.confirm,
        "onClick": onConfirm
      }, null)]);
    };

    var renderRoundButtons = function renderRoundButtons() {
      return _createVNode(ActionBar, {
        "class": bem("footer")
      }, {
        "default": function _default() {
          return [props.showCancelButton && _createVNode(ActionBarButton, {
            "type": "warning",
            "text": props.cancelButtonText || t("cancel"),
            "class": bem("cancel"),
            "color": props.cancelButtonColor,
            "loading": loading.cancel,
            "onClick": onCancel
          }, null), props.showConfirmButton && _createVNode(ActionBarButton, {
            "type": "danger",
            "text": props.confirmButtonText || t("confirm"),
            "class": bem("confirm"),
            "color": props.confirmButtonColor,
            "loading": loading.confirm,
            "onClick": onConfirm
          }, null)];
        }
      });
    };

    var renderFooter = function renderFooter() {
      if (slots.footer) {
        return slots.footer();
      }

      return props.theme === "round-button" ? renderRoundButtons() : renderButtons();
    };

    return function () {
      var width = props.width,
          title = props.title,
          theme = props.theme,
          message = props.message,
          className = props.className;
      return _createVNode(Popup, _mergeProps({
        "ref": root,
        "role": "dialog",
        "class": [bem([theme]), className],
        "style": {
          width: addUnit(width)
        },
        "tabindex": 0,
        "aria-labelledby": title || message,
        "onKeydown": onKeydown,
        "onUpdate:show": updateShow
      }, pick(props, popupInheritKeys)), {
        "default": function _default() {
          return [renderTitle(), renderContent(), renderFooter()];
        }
      });
    };
  }
});
export { stdin_default as default };